module.exports = __webpack_public_path__ + "img/das-neue-miteinander.30b4ed02.jpg";